import { ApiStatuses } from '../../../../../global/models/api-model';

export interface Compensation {
	id: number,
	employment_id: number,
	effective_date: string,
}

export interface ScheduledPayment extends Compensation {
	cash_salary: string,
	utilities: string,
	social_security: string,
	tuition: string,
	er_plan_contributions: string,
	miscellaneous: string,
	housing_cash_allowance: string,
	housing_equity: string,
	housing_provided: string,
	tac: string,
	tac_dc_rsvp: string,
	calculated_housing: string,
	calculated_housing_dc_rsvp: string,
}

export interface OneTimePayment extends Compensation {
	amount: string,
	otp_type: string,
	assessable_compensation: string,
}

export interface CompensationHistoryState {
	pre2018: boolean,
	pre2018ScheduledPayments: ScheduledPayment[],
    post2018ScheduledPayments: ScheduledPayment[],
    allScheduledPayments: ScheduledPayment[],
	oneTimePayments: OneTimePayment[],
	compensationLoaded: boolean,
	loadingCompensation: number,
    allCompensations: Compensation[],
    temporaryCalculatedTotals: CalculatedTotals,

    updateCompensationStatus: ApiStatuses,
}

export enum CompensationHistoryActions {
	ADD_COMPENSATION = 'ADD_COMPENSATION',
	SET_COMPENSATION = 'SET_COMPENSATION',
	SET_COMPENSATION_FAIL = 'SET_COMPENSATION_FAIL',
	TOGGLE_PRE_2018 = 'TOGGLE_PRE_2018',
    SET_COMPENSATION_LOADED = 'SET_COMPENSATION_LOADED',
    ADD_SCHEDULED_PAYMENT = 'UPDATE_SCHEDULED_PAYMENT',
    ADD_ONE_TIME_PAYMENT = 'ADD_ONE_TIME_PAYMENT',
    SET_CALCULATED_TOTALS = 'SET_CALCULATED_TOTALS',

	UPDATE_COMPENSATION_STATUS = 'UPDATE_COMPENSATION_STATUS',

	UNLOAD_COMPENSATION_STATE = 'UNLOAD_COMPENSATION_STATE',
}

export interface CompensationResponseData extends ScheduledPayment {
    otp: OneTimePayment[],
    errors: any[],
}

export interface CalculatedTotals {
    calculated_housing: string,
    calculated_housing_dc_rsvp: string,
    tac: string,
    tac_dc_rsvp: string,
}